
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ToastError extends Vue {
  @Prop()
  messageHtml!: string;
}
